import React, { useState, useEffect } from 'react';
import getPlayers from './util/PlayerService';
import getQuestions from './util/QuestionService';
import { ArrowRightIcon, DocumentDuplicateIcon } from '@heroicons/react/20/solid';

function HigherLower() {
  const baseballTermsDictionary = {
    'H': 'hits',
    '2B': 'doubles',
    '3B': 'triples',
    'HR': 'home runs',
    'RBI': 'RBIs',
    'SB': 'stolen bases',
    'BB': 'walks',
    'SO': 'strikeouts',
  };

  const questionsData = getQuestions();
  const years = questionsData[0];
  const initialStats = questionsData[1];
  const initialPlayers = getPlayers(years);

  const [strikes, setStrikes] = useState(0);
  const [score, setScore] = useState(0);
  const [playStatus, setPlayStatus] = useState(true);
  const [winner, setWinner] = useState(2);
  const [winnerID, setWinnerID] = useState('');
  const [players, setPlayers] = useState(initialPlayers);
  const [stats, setStats] = useState(initialStats);

  useEffect(() => {
    updateData();
  }, []);

  function checkSolution(player, currStat) {
    const currPlayers = players[0];

    if (currPlayers[0][currStat] > currPlayers[1][currStat]) {
      setWinner(0);
      setWinnerID(currPlayers[0].playerID);
      if (player.playerID !== currPlayers[0].playerID) setStrikes(strikes + 1);
      else setScore(score + 1);
    } else if (currPlayers[0][currStat] < currPlayers[1][currStat]) {
      setWinner(1);
      setWinnerID(currPlayers[1].playerID);
      if (player.playerID !== currPlayers[1].playerID) setStrikes(strikes + 1);
      else setScore(score + 1);
    } else {
      setScore(score + 1);
    }

    setPlayStatus(false);
    setTimeout(updateData, 2000);
  }

  function updateData() {
    const nextPlayers = [...players];
    nextPlayers.splice(0, 1);
    setPlayers(nextPlayers);

    const nextStats = [...stats];
    nextStats.splice(0, 1);
    setStats(nextStats);

    setPlayStatus(true);
    setWinner(2);
    setWinnerID('');
  }

  return (
    <div className="container py-5">
      <p className='headline_comp bold'>Higher Lower</p>
      {(strikes === 3 || score === 100) && (
        <div className={`alert ${strikes === 3 ? 'alert-danger' : 'alert-success'} text-center`}>
          <h4>{strikes === 3 ? 'Game Over' : 'Congratulations!'}</h4>
          <p>Your final score: {score}</p>
          <div className="d-flex justify-content-center gap-3 mt-4">
            <button
              className="btn btn-warning"
              onClick={() => window.location.reload()}
            >
              Play again
            </button>
            <button
              className="btn btn-outline-warning"
              onClick={() => {
                navigator.clipboard
                  .writeText(`Score: ${score} \n\nTry the StocksFC Higher Lower Game at https://stocksfcperformance.com/higherlower`)
                  .then(() => alert('Score copied!'));
              }}
            >
              Share your score
            </button>
          </div>
        </div>
      )}

      <div className="text-center mb-4">
        {players[0] && (
          <h5>
            In <strong>{players[0][0].yearID}</strong>, who had more{' '}
            <strong>{baseballTermsDictionary[stats[0]]}</strong>?
          </h5>
        )}
      </div>

      <div className="row text-center mb-4">
        {players[0] &&
          players[0].map((player) => (
            <div className="col-12 col-md-6 mb-3" key={player.playerID}>
              <button
                className="btn btn-light w-100 border shadow-sm"
                onClick={() => checkSolution(player, stats[0])}
                disabled={!playStatus}
              >
                <div className="fw-bold text-uppercase mb-2">
                  {player.nameFirst} {player.nameLast}
                </div>
                <img
                  src={player.image}
                  className={`img-fluid ${!playStatus && winnerID !== player.playerID ? 'opacity-25' : ''}`}
                  style={{ maxHeight: '400px', objectFit: 'cover' }}
                  alt="Player"
                />
              </button>
            </div>
          ))}
      </div>

      <div className="row text-center mb-4">
        <div className="col-md-6">
          <div
            className={`p-3 border rounded ${
              winner === 0 ? 'bg-success text-white fw-bold' : 'bg-secondary text-white'
            }`}
          >
            {playStatus ? '???' : players[0][0][stats[0]]}
          </div>
        </div>
        <div className="col-md-6">
          <div
            className={`p-3 border rounded ${
              winner === 1 ? 'bg-success text-white fw-bold' : 'bg-secondary text-white'
            }`}
          >
            {playStatus ? '???' : players[0][1][stats[0]]}
          </div>
        </div>
      </div>

      <div className="text-center mb-3">
        <p>
          Score: <strong>{score}/100</strong>
        </p>
      </div>

      <div className="d-flex justify-content-center gap-2 mb-5">
        {[0, 1, 2].map((idx) => (
          <div
            key={idx}
            className={`rounded-circle border border-dark me-2`}
            style={{
              width: '30px',
              height: '30px',
              backgroundColor: strikes > idx ? '#dc3545' : 'transparent',
            }}
          />
        ))}
      </div>      
    </div>
  );
}

export default HigherLower;
